import React from "react";
import {
  CardBody,

  Row,
  Col,
  ModalBody,
} from "reactstrap";
import { currencyFormat } from '_helpers';

// import Datetime from "react-datetime";
import { connect } from 'react-redux';
// import { Redirect } from "react-router-dom";
// import * as moment from 'moment';
// import {
//   withScriptjs,
//   withGoogleMap,
//   GoogleMap,
//   Marker
// } from "react-google-maps";

import { feeActions } from '_actions';
import Tabs from 'antd/es/tabs';

const { TabPane } = Tabs;


class BiddingHelpModal extends React.Component {
  constructor(props) {
    super(props);
    console.log("CreateUpdateLocation constructor()", props)
    this.state = {
      activeNav: 1,
      activeTab: '0',
    };
  }



  componentDidMount() {
  }

  tabChange(e) {
    console.log("tabChange", e)
    this.setState({
      activeTab: e
    });
  }

  render() {
    const { fees, streamlineMode } = this.props
    const { liveNyteBookingPercentage, liveNyteBookingHandlingFee, stripeFlatFee, stripePercentage, fetchingFees } = fees
    const combinedPercentage = liveNyteBookingPercentage + stripePercentage
    const combinedFlatFee = liveNyteBookingHandlingFee + stripeFlatFee
    console.log("fees", fees)
    // let remit = num * ticket.price
    // let lvFee = remit * (liveNyteTicketPercentage/100) +
    //             num   * liveNyteTicketFlatFee
    // let stripeFee = (remit + lvFee + stripeFlatFee) / (1 - (stripePercentage/100)) - remit - lvFee
    // console.log("num", num, "remit", remit, "lvFee", lvFee, "stripeFee", stripeFee)
    console.log("BiddingHelpModal: render", this.state)


    if (fetchingFees || fees === undefined) {
      return (
        <div>Loading</div>
      )
    }
    return (
      <ModalBody>
        <Row>
          <Col xs={12}>
            <Tabs defaultActiveKey='0'
              onChange={(e) => this.tabChange(e)}
              activeKey={this.state.activeTab}
            >
              <TabPane tab="Overview" key="0">
                <p className="text-left px-2 py-2">
                  {streamlineMode ?

                    <>
                      <h4>How Inquiries Work</h4>
                      <ul className="modal-list" >
                        <li className="">Send an inquiry to a talent with details about what you're looking for, including expectations and any information needed to start the conversation.</li>
                        <li className="">A chat channel opens between you and the talent, where you can discuss details such as pricing adjustments and expectations, if needed.</li>
                        <li className="">If the talent is not already available, they can send you a binding quote that you can pay to confirm the booking.</li>
                        <li className="">If the talent is available, you can send them a binding offer, which they can accept to confirm the booking.</li>
                        <li className="">Once the transaction is successful, the talent is officially booked for your event.</li>
                      </ul>
                      <h4 className="mt-4">How Offers Work</h4>
                      <ul className="modal-list" >
                        <li className="">Send a binding offer to a talent.</li>
                        <li className="">A chat channel opens between you and the talent--unless one was already created from an inquiry (for example, if you wish to send a trusted talent an offer directly without an inquiry)</li>
                        <li className="">The talent can accept your offer to confirm the booking. You will be charged once the offer is accepted.</li>
                        <li className="">Once the transaction is successful, the talent is officially booked for your event.</li>
                      </ul>
                      <h4 className="mt-4">Quick Tips</h4>
                      <ul className="modal-list" >
                        <li className="">LiveNyte will never overbook talent. You can safely send multiple offers and will only be booked up to your requested number of talent.</li>
                        <li className="">Submit offers in whole USD amounts. Do not include decimal points or the "$" symbol.</li>
                      </ul>
                    </> :
                    <>
                      <h4>How Bidding Works</h4>
                      By submitting a bid or a bid request, you authorize LiveNyte to competitively place your bid against others for a talent's services, pending the talent's approval of your bid.
                      You also authorize the talent to use the <b>'Book Early'</b> option, allowing them to immediately accept your bid at their hourly rate.
                      If you win, you authorize LiveNyte to charge your payment method—never exceeding your maximum bid amount—for the winning price. If the transaction is successful, you've officially booked that talent for your event. The winning price will be set at $1 more than the second-highest bid.
                      <br /><br />
                      LiveNyte will never overbook talent. You're free to place as many bids as you'd like, and you'll only win up to the maximum number of celebrities you've specified.
                      <br /><br />
                      <h4>Book Now</h4>
                      By submitting a <i>'Book Now'</i> request, you authorize LiveNyte to immediately charge your payment method for booking talent during your selected time block at the <i>'Book Now'</i>  price.
                      If the charge is successful, you have successfully booked that talent for your event.
                      <br /><br />
                      <h4>Quick Tips</h4>
                      • Some talent require manual approval for each bid. If a talent you want to book has this setting enabled, you won't be able to use Book Now until they approve your bid request.
                      <br /><br />
                      • Please submit bids in whole USD amounts without using decimal points or the '$' symbol.
                      <br /><br />
                    </>}
                </p>
              </TabPane>
              <TabPane tab={streamlineMode ? "Offer Status" : "Bid Status"} key='1'>
                <p className="text-left px-2 py-2">
                  {streamlineMode ?
                    <>
                      <h4>Offer Status</h4>
                      <ul className="modal-list" >
                        <li className="">An offer marked as <b>Sent</b> means that the talent has not yet accepted your offer.</li>
                        <li className="">An offer marked as <b>Booked</b> means that you have successfully booked that talent.</li>
                        <li className="">An offer marked as <b>Cancelled</b> means that the offer was automatically cancelled due to the slot becoming full.</li>
                        <li className="">An offer marked as <b>Rejected</b> means that the talent rejected your booking offer.</li>
                        <li className="">Once the transaction is successful, the talent is officially booked for your event.</li>
                      </ul>
                    </> :
                    <>
                      <h4>Bid Status</h4>
                      <ul className="modal-list" >
                        <li className=""> A bid marked as Awaiting Approval means that the talent has not yet approved your bid. If there's a talent you want to book immediately, you can use the Book Now option after the talent approves your bid request.</li>
                        <li className="">A bid marked as <b>'Leading'</b> means your bid is currently in the lead.</li>
                        <li className=""> A bid marked as <b>'Lost'</b> means that either you did not have the winning bid when the schedule closed, or another event booked that talent, which caused a time conflict with your bid before the schedule closed.</li>
                        <li className="">If your bid has <b>'Won'</b>, the bid status will change to <b>'Booked',</b> and you will be charged via your preferred payment method (located in the Payments tab). The new booking will appear on your event page. The amount you're charged is $1 more than the second-highest bidder's.</li>
                        <li className="">If your bid status changes to <b>'Insufficient Funds'</b> after a schedule has closed, it means your bid has been lost because we were unable to successfully charge your payment method for the winning bid amount. Please update your payment methods to ensure you have sufficient funds for future bookings.</li>
                        <li className="">If your bid status changes to <b>'Insufficient Funds'</b> after a <i>'Book Now'</i> attempt, it means we were unable to charge your payment method for the <i>'Book Now'</i>  price. Please update your payment methods to ensure you have the appropriate available credit for <i>'Book Now'</i>  and then retry the <i>'Book Now'</i>  option.</li>
                      </ul>
                    </>}
                </p>
              </TabPane>
              <TabPane tab="Grievances" key="2">
                <p className="text-left px-2 py-2">
                  <h4>Grievances</h4>
                  <ul className="modal-list" >
                    <li className="">If you have a significant grievance regarding a booking (e.g., talent was substantially late, no-show, etc.), you have up to four days after the event to file a case with LiveNyte.</li>
                    <li className="">To do this, click 'Help' on the talent's booking you wish to submit a case about, select <b>Freeze Payment</b> and fill out the case details.
                      <li className="">LiveNyte will then assist you and the talent in reaching a resolution.</li></li>
                    <li className="">Abuse of this feature may result in account suspension or termination.</li>
                    <li className="">Note: We highly recommend that you read the talent's reviews, written by other businesses who have booked that talent.</li>
                  </ul>
                </p>
              </TabPane>
              <TabPane tab="Fees" key="3">
                <p className="text-left px-2 py-2">
                  <h4>Booking Fees <span className="text-muted">(Paid by the business)</span></h4>
                  <div className="title mb-2 text-muted">
                    LiveNyte fees help power secure payments, protected bookings, and built-in audience reach.
                    Fees apply to talent bookings and ticket sales and are always shown upfront.
                  </div>
                  {streamlineMode ? (
                    <div>
                      <ul className="modal-list">
                        <li>
                          When you book talent on LiveNyte, fees support the platform features that make bookings reliable,
                          protected, and easy to manage from start to finish.
                        </li>

                        <li>
                          The payment processor collects {stripePercentage}% + {currencyFormat('us', stripeFlatFee)} , and LiveNyte collects
                          {liveNyteBookingPercentage}% + {currencyFormat('us', liveNyteBookingHandlingFee)}. These fees are clearly shown before you send a booking offer or confirm a booking.
                        </li>


                        <li>
                          Booking through LiveNyte includes secure payments, built-in protection, and targeted exposure
                          to local fans and to the followers of the talent you book—often replacing the need for additional
                          advertising or third-party tools.
                        </li>
                      </ul>
                    </div>
                  ) :
                    (
                      <div>
                        <ul className="modal-list" >
                          <li className="">  LiveNyte lists talent services for {combinedPercentage}% + {currencyFormat('us', combinedFlatFee)} to support the services that help your event succeed.</li>
                          <li className=""> From this, LiveNyte collects {liveNyteBookingPercentage}% + {currencyFormat('us', liveNyteBookingHandlingFee)} and pays the payment processor {stripePercentage}% + {currencyFormat('us', stripeFlatFee)}.</li>
                          <li className=""> These fees cover more than just payment processing. Booking through LiveNyte gives you payment assurance, built-in protection, and targeted promotion to local fans and to the followers of the talent you book—all within a platform designed specifically for live events.</li>
                          <li className="">For many businesses, this means getting meaningful exposure and operational support without needing to spend additional budget on advertising or third-party tools. We’re focused on making sure the fees you pay translate directly into real value for your event.</li>
                          <li className=""><i>LiveNyte reserves the right to change its fees in the future.</i></li>
                        </ul>
                      </div>
                    )}
                </p>

              </TabPane>
            </Tabs>
          </Col>
        </Row>
      </ModalBody>
    );
  }
}

function mapStateToProps(state) {
  const { feesData, systemData } = state;
  const { fees, fetchingFees } = feesData;
  const { streamlineMode } = systemData
  return {
    fees, fetchingFees,
    streamlineMode
  };
}

const connectedBiddingHelpModal = connect(mapStateToProps)(BiddingHelpModal);
export { connectedBiddingHelpModal as BiddingHelpModal }; 